// extracted by mini-css-extract-plugin
export default {"video":"Calibration_video__8WO1z","videoPlayerHidden":"Calibration_videoPlayerHidden__lUvlG"};